import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    FormControl,
    Select,
    MenuItem,
    InputLabel,
    makeStyles,
} from '@material-ui/core';
import type { PROSJEKT_TYPE } from '@klp/formgenerator/interfaces';
import { useGetProjectTypesQuery } from '../../../services/rtkApi';
import { getProjectTypeKey } from '@klp/prosjekt/utils';

const useStyles = makeStyles((theme) => ({
    formField: {
        '& .MuiTypography-root': {
            color: theme.palette.text.primary,
        },
        '& .Mui-disabled': {
            cursor: 'not-allowed',
        },
        '& .MuiFormLabel-asterisk': {
            color: theme.palette.error.main,
            fontSize: '1.5rem',
        },
    },
}));

export interface ProsjektTypeSelectProps {
    value?: PROSJEKT_TYPE;
    touched?: boolean;
    error?: string;
    onChange: (type: PROSJEKT_TYPE | undefined) => void;
}

export const ProsjektTypeSelect: React.FC<ProsjektTypeSelectProps> = ({
    value,
    touched,
    error,
    onChange,
}) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { data: projectTypes, isLoading: getProjectTypesIsLoading } =
        useGetProjectTypesQuery({ includeInitiatives: true });

    const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const selectedType = event.target.value as PROSJEKT_TYPE;
        onChange(selectedType);
    };
    return (
        <FormControl
            required={true}
            fullWidth={true}
            error={touched && !!error}
            margin="normal"
        >
            <InputLabel id="project-type-label" className={classes.formField}>
                {t('project.opprettProsjekt.type')}
            </InputLabel>
            <Select
                labelId="project-type-label"
                id="type"
                name="type"
                value={value || ''}
                onChange={handleChange}
                disabled={getProjectTypesIsLoading}
                error={touched && !!error}
            >
                {projectTypes &&
                    Object.values(projectTypes).map((type) => (
                        <MenuItem key={type} value={type}>
                            {t(`${getProjectTypeKey(type)}`)}
                        </MenuItem>
                    ))}
                {!projectTypes && (
                    <MenuItem disabled={true}>{t('general.loading')}</MenuItem>
                )}
            </Select>
        </FormControl>
    );
};
